import { StaticMarketData } from './market.ts';
import { Assets } from './assets.ts';
import { Person } from './person.ts';
import { RetirementStrategy } from './retirement_strategy.ts';

export class RetirementConfig {
  static deserialize(s: string): RetirementConfig {
    const j = JSON.parse(s) as Record<string, string>;

    return new RetirementConfig(
      Person.deserialize(j.person),
      Assets.deserialize(j.initialAssets),
      StaticMarketData.deserialize(j.market),
      RetirementStrategy.deserialize(j.strategy),
    );
  }

  _person: Person;
  _initialAssets: Assets;
  _market: StaticMarketData;
  _strategy: RetirementStrategy;

  constructor(
    person: Person,
    initialAssets: Assets,
    market: StaticMarketData,
    strategy: RetirementStrategy,
  ) {
    this._person = person;
    this._initialAssets = initialAssets;
    this._market = market;
    this._strategy = strategy;
  }

  serialize(): string {
    return JSON.stringify({
      person: this.person.serialize(),
      initialAssets: this.initialAssets.serialize(),
      market: this.market.serialize(),
      strategy: this.strategy.serialize(),
    });
  }

  get person() {
    return this._person;
  }

  get initialAssets() {
    return this._initialAssets;
  }

  get market() {
    return this._market;
  }

  get strategy() {
    return this._strategy;
  }

  clone(): RetirementConfig {
    return new RetirementConfig(
      this.person.clone(),
      this.initialAssets.clone(),
      this.market.clone(),
      this.strategy.clone(),
    );
  }

  zeroVariances(): RetirementConfig {
    const c = this.clone();
    c._market = this.market.zeroVariance();
    return c;
  }
}
